<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :params="params"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/shops`;
    this.setLink += `/${this.id}/shops`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "shops",
          label: "Выберите магазины, которые нужно добавить",
          type: "selects",
          modal: "shop",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "partners",
      setLink: "partners",
      columns: [
        {
          key: "name",
          title: "Название магазина",
        },
        {
          key: "address",
          title: "Адрес магазина",
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
